import * as Sentry from '@sentry/browser';
import Swal from 'sweetalert2';
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";

// https://github.com/twbs/examples/blob/main/webpack/src/js/main.js
//
// Import our custom CSS
import '../scss/project.scss';
import '@xyflow/react/dist/style.css';
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import 'handsontable/styles/ht-theme-horizon.min.css';

import './bootstrap';
import './tour'

if (process.env.SENTRY_DSN) {
    const APP_VERSION = `${process.env.APP_VERSION}`
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        release: `${process.env.SENTRY_RELEASE_NAME}@${APP_VERSION}`,
        integrations: [Sentry.browserTracingIntegration()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE || 1.0,
        environment: process.env.SENTRY_RELEASE_NAME || 'production',
    });
}

document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(popover => {
        new window.bootstrap.Popover(popover)
    })

document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(tooltip => {
        new window.bootstrap.Popover(tooltip, {trigger: "hover focus"})
    })

const selectionSpansMultipleDays = () => {
    const dates = new Set(
        Array.from(document.querySelectorAll('[data-schedule-date]:checked')).map(el => el.dataset.scheduleDate)
    )
    return dates.size > 1
}

const confirmMultipleDaysCompletion = (onConfirm) => {
    Swal.fire({
        title: "The selected tasks are scheduled on different days. Complete them anyway?",
        icon: 'warning',
        showCancelButton: true,
    }).then((result) => {
        if (result.isConfirmed) onConfirm()
    })
}

document.addEventListener("htmx:confirm", (e) => {
    if (e.detail.elt.dataset.confirmIfMultipleDays !== undefined) {
        if (!selectionSpansMultipleDays()) return
        e.preventDefault()
        confirmMultipleDaysCompletion(() => e.detail.issueRequest(true))
        return
    }
    if (!e.detail.question) return
    e.preventDefault()
    Swal.fire({
        title: `${e.detail.question}`,
        icon: 'warning',
        showCancelButton: true,
    }).then((result) => {
        if (result.isConfirmed) {
            e.detail.issueRequest(true);
        }
    })
})

document.addEventListener("DOMContentLoaded", async () => {
    flatpickr('input[type="date"], .flatpickr', {
        dateFormat: "Y-m-d"
    });
});

document.body.addEventListener('htmx:afterSwap', function (e) {
    e.target.querySelectorAll('.flatpickr').forEach(function (el) {
        if (!el._flatpickr) {
            flatpickr(el, {
                dateFormat: "Y-m-d",
            });
        }
    });
    document.querySelectorAll('[data-bs-toggle="popover"]')
        .forEach(popover => {
            new window.bootstrap.Popover(popover)
        })

});

document.addEventListener('change', function (e) {
    if (e.target.matches('table input[type="checkbox"]')) {
        const tr = e.target.closest('tr');
        if (tr) {
            tr.classList.toggle('table-active', e.target.checked);
        }
    }
});
